import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

import MultiSelectOption from "./MultiSelectOption";
import NextButton from "./NextButton";

import { validateMultiSelectQuestion } from "../utils/questionUtils";
import { isDark } from "@common/utils/colors";
import SkipButton from "./SkipButton";

const PREFIX = "MultiSelect";

const classes = {
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  body: `${PREFIX}-body`,
  required: `${PREFIX}-required`,
  subText: `${PREFIX}-subText`,
  navigation: `${PREFIX}-navigation`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  borderRadius: "0px",
  boxShadow: "none",
  padding: theme.spacing(2, 3),
  backgroundColor: theme.palette.primary.main,

  [`& .${classes.header}`]: {
    marginBottom: "20px",
  },

  [`& .${classes.title}`]: {
    fontWeight: 600,
    color: isDark(theme.palette.primary.main) ? "#FFF" : "#000",
  },

  [`& .${classes.body}`]: {
    display: "flex",
    flexDirection: "column",
    padding: "0",
  },

  [`& .${classes.required}`]: {
    color: theme.palette.error.main,
  },

  [`& .${classes.subText}`]: {
    color: isDark(theme.palette.primary.main) ? "#FFF" : theme.palette.grey["500"],
    marginBottom: "5px",
  },

  [`& .${classes.navigation}`]: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    padding: theme.spacing(0, 3),
    marginBottom: theme.spacing(2),
  },
}));

const MultiSelect = ({ question, responses, setResponses, index, total, pageNum, setPageNum }) => {
  const theme = useTheme();

  return (
    <Fragment>
      <StyledBox>
        <div className={classes.header}>
          <Typography
            variant="body1"
            style={{ color: isDark(theme.palette.primary.main) ? "#FFF" : "#676767" }}
          >
            {index} of {total}
          </Typography>
          <Typography variant="h5" className={classes.title}>
            {question.question_title}
          </Typography>
          {question.required && <span className={classes.required}>* Required</span>}
        </div>
        <div className={classes.body}>
          {question.use_option_limit ? (
            <span className={classes.subText}>
              Select up to <b>{question.option_limit}</b> option(s)
            </span>
          ) : (
            <span className={classes.subText}>Select as many as you like</span>
          )}
          {question.question_options &&
            question.question_options.map((option, i) => (
              <MultiSelectOption
                key={i}
                option={option}
                values={responses[pageNum]}
                responses={responses}
                setResponses={setResponses}
                qnNum={pageNum}
                disabled={
                  responses[pageNum].use_option_limit &&
                  responses[pageNum].selected_options &&
                  responses[pageNum].selected_options.length >= question.option_limit
                }
              />
            ))}
        </div>
      </StyledBox>
      <div
        className={classes.navigation}
        style={{
          visibility: validateMultiSelectQuestion(responses[pageNum], question.required)
            ? "visible"
            : "hidden",
        }}
      >
        {!responses[pageNum].selected_options ||
        responses[pageNum].selected_options.length === 0 ? (
          <SkipButton onClickFn={() => setPageNum(pageNum + 1)} />
        ) : (
          <NextButton onClickFn={() => setPageNum(pageNum + 1)} />
        )}
      </div>
    </Fragment>
  );
};

export default MultiSelect;
